import * as actions from 'redux/constants';
import { STATUSES, HOSTED_PAGE_TYPES } from 'consts';
import {
  getDefaultMessages,
  sendErrorMessage,
  iframeMessages
} from 'services/iframeService';

const {
  sendGetPageFailMsg: sendGetBeneficiaryPageFail,
  sendStartMsg: sendStartMessageBeneficiary,
  sendSuccessMsg: sendSuccessMessageBeneficiary,
  sendFailMsg: sendFailMessageBeneficiary
} = getDefaultMessages(HOSTED_PAGE_TYPES.beneficiaryTokenization);

const beneficiaryTokenizationMiddleware = store => next => action => {
  const {
    global: { isSdk }
  } = store.getState();
  if (!isSdk) {
    return next(action);
  }

  switch (action.type) {
    case actions.GET_BENEFICIARY_TOKENIZATION_PAGE_FAIL: {
      sendGetBeneficiaryPageFail(action.payload.error);
      break;
    }
    case actions.GET_BENEFICIARY_TOKENIZATION_PAGE_SUCCESS: {
      const { status } = action.payload.data;
      if (status === STATUSES.done) {
        sendGetBeneficiaryPageFail('BENEFICIARY_TOKENIZATION_PAGE_ALREADY_IN_USE');
      }
      break;
    }
    case actions.GET_PAYOUT_METHOD_TYPES_FAIL: {
      sendErrorMessage({
        type: iframeMessages.BENEFICIARY_TOKENIZATION_ON_FAILURE,
        error: action.payload.error,
        meta: { closeIframe: true }
      });
      break;
    }
    case actions.GET_PAYOUT_REQUIRED_FIELDS_FAIL: {
      sendErrorMessage({
        type: iframeMessages.BENEFICIARY_TOKENIZATION_ON_FAILURE,
        error: action.payload.error,
        meta: { closeIframe: true }
      });
      break;
    }
    case actions.CREATE_BENEFICIARY_START: {
      sendStartMessageBeneficiary();
      break;
    }
    case actions.CREATE_BENEFICIARY_SUCCESS: {
      sendSuccessMessageBeneficiary({
        eventType: iframeMessages.BENEFICIARY_CREATE_SUCCESS,
        data: action.payload.data,
        meta: {
          closeIframe: true
        }
      });
      break;
    }
    case actions.CREATE_BENEFICIARY_FAIL: {
      sendFailMessageBeneficiary({
        eventType: iframeMessages.BENEFICIARY_CREATE_FAIL,
        error: action.payload.error,
        meta: {
          closeIframe: true
        }
      });
      break;
    }
  }

  next(action);
};

export default beneficiaryTokenizationMiddleware;
